import React from 'react'

export default function MeetingValue({meetValue}) {
  return (
    <>
    <section className="meetpage-value">
        <div className="container">
            <div className="row">

                <div className="col-lg-8 col-md-7">
                    <div className="meetvalue-box">
                        <h2 className='heading'>{meetValue?.title}</h2>
                        <div>
                            <p>{meetValue?.para}</p>
                            <ul>
                                {meetValue?.list?.map((item, index) => (
                                    <li key={index}>
                                    <img src="/image/check.webp" alt="check" loading="lazy" /> 
                                    {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-lg-4 col-md-5">
                    <img src={meetValue?.image} alt="value" className="img-responsive wow animate__animated animate__fadeInRight" data-wow-delay="0.2s" data-wow-duration="1s" loading="lazy"/>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
